import { CompaniesList as ICompaniesList } from "@/api/models/companies-list";
import { Company as ICompany } from "@/api/models/company";
import { isRoot } from "@/plugins/roles";
import { getCurrentUserId } from "@/plugins/roles";
import company, { CompanyListParams } from "@/getinfo-api/company";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Employee as IEmployee } from "@/api/models/employee";
import { settingStorageLocalApi } from "@/getinfo-api/settingsStorage";
import { uniqBy } from "lodash";
import user from "@/store/modules/users/currentUserInfo";

export default {
  state: {
    allCompanies: [],
    companies: [],
    selectedCompany: {},
    selectedCompanyOwner: false,
    employees: [],
    rolesInCompany: [],
    currentEmployee: undefined
  },
  actions: {
    usersCompanies(ctx: any) {
      if (isRoot()) {
        let params: CompanyListParams = {
          limit: 400
        };

        company(params).then((res: { data: ICompaniesList }) => {
          let comp = res.data.companies;
          ctx.commit("updateCompanies", comp);
          user.state.user.companies = comp;
        });
      } else {
        let params: CompanyListParams = {
          employeesIds: [getCurrentUserId()],
          limit: 400
        };

        company(params).then((res: { data: ICompaniesList }) => {
          let comp = res.data.companies;
          if (comp.length) {
            const enabledCompanies = comp.filter(el => el.enabled);
            ctx.commit("updateCompanies", enabledCompanies);
            user.state.user.companies = uniqBy(
              [...user.state.user.companies, ...enabledCompanies],
              "id"
            );
          } else {
            const enabledCompanies = user.state.user.companies.filter(
              el => el.enabled
            );
            ctx.commit("updateCompanies", enabledCompanies);
          }
        });
      }
    },
    selectCompany(ctx: any, company: ICompany) {
      ctx.commit("updateSelect", company);
      user.state.user.company = company;
    },
    async getRolesInCompany(ctx: any, company: ICompany) {
      if (company.id) {
        let params: EmployeeListParams = {
          id: company.id,
          userIds: [getCurrentUserId()]
        };

        try {
          let params: EmployeeListParams = {
            id: company.id,
            userIds: [getCurrentUserId()]
          };

          const response = await employee(params);

          response.data.employees?.length
            ? ctx.commit("updateRoles", response.data.employees[0])
            : undefined;
        } catch (e) {
          if (e.response.status === 403) {
            ctx.commit("clearUserIsEmployee");
          }
        }

        // employee(params).then((res: { data: IEmployeesList2 }) => {
        //   if (res.data.employees.length > 0) {
        //     ctx.commit("updateRoles", res.data.employees[0]);
        //   } else {
        //     ctx.commit("clearUserIsEmployee");
        //   }
        // });
      }
    },
    clearStore(ctx: any) {
      ctx.commit("clearCompanyStore");
    }
  },
  mutations: {
    addCompanies(state: any, companies: ICompany[]) {
      state.allCompanies = uniqBy([...state.allCompanies, ...companies], "id");
      state.companies = uniqBy([...state.companies, ...companies], "id");
    },
    clearCompanyStore(state: any) {
      state.allCompanies = [];
      state.companies = [];
      state.selectedCompany = {};
      state.selectedCompanyOwner = false;
      state.employees = [];
      state.rolesInCompany = [];
      state.currentEmployee = undefined;
      if (localStorage.getItem("ownerSelectedCompany")) {
        delete localStorage.ownerSelectedCompany;
      }
      if (localStorage.getItem("employee")) {
        delete localStorage.employee;
      }
    },
    async updateCompanies(state: any, companies: Array<ICompany>) {
      state.companies = uniqBy([...state.companies, ...companies], "id");
      if (state.companies) {
        if (localStorage.getItem("selectedCompany")) {
          const found = state.companies.find((element: any) => {
            return element.id === localStorage.selectedCompany;
          });
          state.selectedCompany = found ?? state?.companies[0];
          if (!state.selectedCompany) {
            delete localStorage.selectedCompany;
          }
        } else {
          const {
            companyId
          } = await settingStorageLocalApi.User.getUserCompany(
            getCurrentUserId()
          );
          if (companyId) {
            state.selectedCompany = state.companies.find((element: any) => {
              return element.id === companyId;
            });
            localStorage.setItem("selectedCompany", companyId);
            localStorage.setItem(
              "ownerSelectedCompany",
              state.selectedCompany?.owner?.id
            );
          } else {
            localStorage.setItem("selectedCompany", state.companies[0].id);
            state.selectedCompany = state.companies[0];
            localStorage.setItem(
              "ownerSelectedCompany",
              state.companies[0]?.owner?.id
            );
          }
        }
      }
      if (state.selectedCompany) {
        state.selectedCompanyOwner =
          state.selectedCompany?.owner?.id === getCurrentUserId();
      }
    },
    updateSelect(state: any, company: ICompany) {
      state.selectedCompany = company;
      if (company && company.id) {
        localStorage.setItem("ownerSelectedCompany", company.owner?.id);
        localStorage.setItem("selectedCompany", company.id);
        if (state.selectedCompany) {
          state.selectedCompanyOwner =
            state.selectedCompany?.owner?.id === getCurrentUserId();
        }
      }
    },
    updateRoles(state: any, employee: IEmployee) {
      localStorage.setItem("employee", JSON.stringify(employee));
      state.rolesInCompany = employee.roles;
      state.currentEmployee = employee;
    },
    clearUserIsEmployee(state: any) {
      if (localStorage.getItem("employee")) {
        delete localStorage.employee;
      }
      state.currentEmployee = undefined;
    }
  },
  getters: {
    companiesList(state: any) {
      return state.companies;
    },

    selectedCompany(state: any) {
      return state.selectedCompany;
    },

    roles(state: any) {
      return state.rolesInCompany;
    },

    userIsCompanyOwner(state: any) {
      return state.selectedCompanyOwner;
    },

    userIsEmployee(state: any) {
      return state.currentEmployee;
    }
  }
};
